<h1 mat-mdc-dialog-title>Suppression de l'utilisateur {{ data.porteur.porteur }}</h1>
<div mat-dialog-content>
  <p>Etes-vous certain de vouloir supprimer l'utilisateur {{ data.porteur.porteur }} ?</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="refuse()">Annuler</button>
  <button mat-raised-button (click)="valid()" cdkFocusInitial class="color">Confirmer</button>
</div>